import React from "react";
import GlobalPharmacyCart from 'src/Components/GlobalPharmacyCart';

const WebsitePharmacyCart: React.FC = () => {
    return (
        <div className="pharmacy-banner">
            <div className="container-1400">
                <div className="py-4">
                    <GlobalPharmacyCart
                        type="website"
                    />
                </div>
            </div>
        </div>
    );
};

export default WebsitePharmacyCart;